import React from 'react';
import { Container } from '../Container';
export function StatsBar() {
  const stats = [{
    value: 'Full-Service',
    label: 'Representation'
  }, {
    value: 'Brand + Content + Deals',
    label: 'Under one roof'
  }, {
    value: 'Est. 2026',
    label: 'Atlanta, GA'
  }];
  return <section className="border-b border-brand-gray300 bg-brand-black py-[clamp(48px,6vw,90px)] text-brand-white" data-id="element-151" data-mp="aq44ktch5puh">
      <Container data-id="element-152" data-mp="fpqmhg38zu9m">
        <dl className="grid grid-cols-3 gap-px bg-white/15 max-[720px]:grid-cols-1" data-id="element-153" data-mp="fo5rjpd0u9b8">
          {stats.map(stat => <div key={stat.label} className="bg-brand-black px-[clamp(20px,2.5vw,36px)] py-[clamp(24px,3vw,40px)]" data-id="element-154" data-mp="kmqs5pw6qv07">
              <dt className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/55" data-id="element-155" data-mp="th52de1uzfcg">
                {stat.label}
              </dt>
              <dd className="mt-4 text-[clamp(1.6rem,2.8vw,2.6rem)] font-black uppercase leading-[1.02] tracking-[-0.03em]" data-id="element-156" data-mp="yh9k17ei6g49">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </Container>
    </section>;
}